// extracted by mini-css-extract-plugin
export default {"ourPostsContentDesktop":"OurPosts_ourPostsContentDesktop__nS8LT"};